export enum CustomerVisibility {
  NotVisible = 0,
  Visible = 1,
}
